import React, { useEffect, useState, useContext } from "react";
import SellerSidebar from "../../../navigation/sellerNavigation";
import { getData } from "../../../fetchRoutes/getData";
import PropertyCard from "../../../utility/propertyCard";
import SellerMobileSidebar from "../../../navigation/sellerMobileNavigation";
import { DeviceContext } from "../../../context/deviceContext";

export default function MyBidsContainer() {

    const myBidsUrl = process.env.REACT_APP_MY_BIDS;
    const highestBids = process.env.REACT_APP_GET_HIGHEST_BID;

    const {isMobile}= useContext(DeviceContext);
    

    const [winningBids, setWinningBids] = useState([]);
    const [losingBids, setLosingBids] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const propertiesPerPage = 8;

    useEffect(() => {
        const fetchMyBids = async () => {
            setLoading(true);
            try {
                await getData(highestBids);
                const response = await getData(myBidsUrl);
                if (response.status === 'Success') {
                    setWinningBids(response.data.winning || []);
                    setLosingBids(response.data.losing || []);
                }
            } catch (error) {
                setError(error.message || 'Something went wrong');
            } finally {
                setLoading(false);
            }
        };

        fetchMyBids();
        // eslint-disable-next-line 
    }, [myBidsUrl]);

    const allBids = [...winningBids.map(bid => ({ ...bid, winning: true })), ...losingBids.map(bid => ({ ...bid, losing: true }))];
    
    const totalPages = Math.ceil(allBids.length / propertiesPerPage);
    const indexOfLast = currentPage * propertiesPerPage;
    const indexOfFirst = indexOfLast - propertiesPerPage;
    const currentBids = allBids.slice(indexOfFirst, indexOfLast);

    return (
        <main className="sellerDashboard">
            {isMobile ? <SellerMobileSidebar/> :<SellerSidebar />}
            <div className="bidsContainer">
                <h1 className="containerTitle">MY BIDS</h1>

                {loading && <p>Loading bids...</p>}
                {error && <p className="errorMessage">{error}</p>}

                <div className="propertyList">
                    {!loading && !error && currentBids.length > 0 ? (
                        currentBids.map((property, index) => (
                            <PropertyCard
                                key={property._id || `bid-${index}`}
                                property={property}
                                myBids={true}
                                winning={property.winning}
                                losing={property.losing}
                            />
                        ))
                    ) : (
                        !loading && !error && <p className="noPropertiesText">No bids found.</p>
                    )}
                </div>

                {totalPages > 1 && (
                    <div className="pagination">
                        <button
                            onClick={() => setCurrentPage(prev => prev - 1)}
                            disabled={currentPage === 1}
                            className={`btnPagination ${currentPage === 1 ? 'disabled' : ''}`}
                        >
                            Previous
                        </button>
                        <span className="pageInfo">Page {currentPage} of {totalPages}</span>
                        <button
                            onClick={() => setCurrentPage(prev => prev + 1)}
                            disabled={currentPage === totalPages}
                            className={`btnPagination ${currentPage === totalPages ? 'disabled' : ''}`}
                        >
                            Next
                        </button>
                    </div>
                )}
            </div>
        </main>
    );
}

